import _str from "shared/util/_str";

export const VOTE_DRAG_THRESHOLD = 60;
export const MIN_VELOCITY = 20;
export const MAX_VELOCITY = 80;
export const CARD_ASPECT_RATIO = 7 / 10;
export const NAVBAR_HEIGHT = 60;
export const FAB_CONTAINER_HEIGHT = 72;
export const VOTE_INPUT_METHOD = {
	Drag: "DRAG",
	Tap: "TAP",
	HotKey: "HOT_KEY",
};

export const STACKSWAP_TRANSITION = 300;
export const DESKTOP_CARD_TRANSITION = 400;

export const FETCH_STATUSES = {
	complete: "complete",
	loading: "loading",
	error: "error",
};

export const STACKS = {
	JUST_FOR_YOU: "JUST_FOR_YOU", // this is doubletake/locals
	NEARBY: "NEARBY",
	POPULAR: "POPULAR",
	MOST_QUESTIONS: "MOST_QUESTIONS",
	ONLINE_NOW: "ONLINE_NOW",
	NEW_USERS: "NEW_USERS",
};

export const STACKS_MENU_CLASS = "stacks-menu";

export const STACKS_MENU_LABELS = {
	[STACKS.JUST_FOR_YOU]: _str("Recommended"),
	[STACKS.NEARBY]: _str("Nearby"),
	[STACKS.POPULAR]: _str("Popular"),
	[STACKS.NEW_USERS]: _str("New People"),
	[STACKS.MOST_QUESTIONS]: _str("Question Pros"),
	[STACKS.ONLINE_NOW]: _str("Online"),
};

export const STACKS_CONTENT_LABELS = {
	[STACKS.JUST_FOR_YOU]: _str("Recommended Just For You"),
	[STACKS.NEARBY]: _str("Nearby"),
	[STACKS.POPULAR]: _str("Popular"),
	[STACKS.NEW_USERS]: _str("New People"),
	[STACKS.MOST_QUESTIONS]: _str("Most Questions Answered"),
	[STACKS.ONLINE_NOW]: _str("Recently Online"),
};

export const STACKS_TOOLTIP_DESKTOP_CONTENT = {
	[STACKS.JUST_FOR_YOU]: _str("OkCupid’s top recommendations based on your preferences."),
	[STACKS.NEARBY]: _str("Nearby people in your area."),
	[STACKS.POPULAR]: _str("Connect with some of the most liked people."),
	[STACKS.NEW_USERS]: _str("Connect with people who just joined OkCupid."),
	[STACKS.MOST_QUESTIONS]: _str("OkCupid Questions determine compatibility. These people have answered the most OkCupid questions."),
	[STACKS.ONLINE_NOW]: _str("People recently online are most likely to respond."),
};

// the same as desktop, except there are no tooltips for paid stacks
export const STACKS_TOOLTIP_MOBILE_CONTENT = {
	...STACKS_TOOLTIP_DESKTOP_CONTENT,
	[STACKS.POPULAR]: null,
	[STACKS.NEW_USERS]: null,
};

export const STACKS_STATUSES = {
	NO_MATCHES: "NO_MATCHES",
	OUT_FOR_THE_DAY: "OUT_FOR_THE_DAY",
	PAYWALL: "PAYWALL",
	GLOBAL_PREFS_LIQUIDITY: "GLOBAL_PREFS_LIQUIDITY",
};

// keep this in sync with the value in apps/quickmatch/util/_variables.scss
export const STACKS_MENU_HEIGHT_MOBILE = 105;

// this one doesn't have a css equivalent, so it's just a magic number. it
// should be kept in sync with apps/quickmatch/components/StackTitle.mobile.scss
export const STACKS_TITLE_HEIGHT_MOBILE = 52;

export const STACKS_VIEWS = {
	SWIPE: "SWIPE",
	GRID: "GRID",
};

export const STACKS_VIEW_LABELS = {
	[STACKS_VIEWS.SWIPE]: _str("One at a time"),
	[STACKS_VIEWS.GRID]: _str("See all"),
};

export const GRID_VIEW_UPGRADE_LINK = "/upgrade?cf=stacks_grid_view";



// WEBPACK FOOTER //
// ./src/apps/quickmatch/util/constants.js